export const routes = (prefix = `lab`) => [
    {
        path: `/${prefix}/queue`,
        name: `${prefix}.queue.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.queue.index`,
                PageDescription: "Lab: Queue",
            },
        },
    },
    {
        path: `/${prefix}/past-queue`,
        name: `${prefix}.past-queue.index`,
        component: () => import('./PastQueue.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.past-queue.index`,
                PageDescription: "Lab: Past Queue",
            },
        },
    },
    {
        path: `/${prefix}/pending-investigations-print`,
        name: `${prefix}.pending-investigations-print.index`,
        component: () => import('./prints/PendingInvestigations.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.queue.index`,
                PageDescription: "Lab: Queue",
            },
        },
    },
];
